<div *ngIf="pendingTicket" (click)="viewQuery(pendingTicket.objectId)" class="tw-font-body tw-fixed tw-bottom-[80px] tw-left-1/2 tw-translate-x-[-50%] tw-w-full tw-h-[96px] tw-flex tw-items-center tw-gap-[30px] tw-px-[24px] tw-py-[16px] tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-shadow-z10 tw-bg-gradient-yellow-to-white tw-z-[50]">
    <div class="tw-relative tw-flex tw-flex-col tw-w-full">
      <div class="tw-flex tw-items-center tw-relative tw-mb-2">
        <img src="/assets/gifs/blinking-red-dot.gif"
             alt="red-blink-circle"
             class="tw-w-2 tw-aspect-square tw-absolute" />
        <span i18n="@@openQuery" class="tw-text-100 tw-text-gray-700 tw-uppercase tw-ml-3 tw-tracking-[1.36px]">Open Query</span>
        <span class="tw-text-100 tw-text-gray-900 tw-font-bold tw-capitalize">&nbsp;- 
          {{excludedSubCategories?.includes(pendingTicket?.llmResponse?.subcategory) ? pendingTicket?.llmResponse?.category : pendingTicket?.llmResponse?.subcategory}}</span>
      </div>
      <div class="tw-text-gray-800 tw-text-300 tw-leading-snug">
        <span i18n="@@drIsLooking" class="tw-font-bold">{{userName}}, your doctor is looking into your query.</span> &nbsp;
        <span i18n="@@resIn24Hrs">Expect a response within 24 hrs.</span>
      </div>
    </div>
</div>

<div *ngIf="audioMessageInTicket && showDiscomfortBanner" (click)="viewQuery(activeDiscomfortTicket.objectId)" class="tw-font-body tw-fixed tw-bottom-[80px] tw-left-1/2 tw-translate-x-[-50%] tw-w-full tw-flex tw-items-center tw-gap-[30px] tw-px-[24px] tw-py-[16px] tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-bg-gradient-yellow-to-white tw-shadow-z10 tw-z-[50]">
    <div class="tw-relative tw-flex tw-flex-col tw-w-full">
      <div class="tw-flex tw-items-center tw-relative tw-mb-2">
        <cs-icon class="tw-h-3 tw-w-3" [iconName]="'/rebranding/v1/green_check'"></cs-icon>
        <span i18n="@@resolvedQuery" class="tw-text-100 tw-text-gray-700 tw-uppercase tw-ml-2 tw-tracking-[1.36px]">Resolved</span>
        <span class="tw-text-100 tw-text-gray-900 tw-font-bold tw-capitalize">&nbsp;- 
          {{excludedSubCategories?.includes(activeDiscomfortTicket?.llmResponse?.subcategory) ? activeDiscomfortTicket?.llmResponse?.category : activeDiscomfortTicket?.llmResponse?.subcategory}}</span>
        <img class="tw-absolute tw-right-0 tw-w-3" src="/assets/icons/chevron_right_teal.svg" alt="chevron right"/>
      </div>
      <div class="tw-text-gray-800 tw-text-300 tw-leading-snug tw-mb-2">
        <span i18n="@@drAnswered" class="tw-font-bold">Your doctor has answered your query.</span><br />
        <span i18n="@@listenToVoiceNote">Please listen to this voice note.</span>
      </div>
      <div (click)="$event.stopPropagation()">
        <app-custom-audio-waveform 
        [voiceUrl]="audioMessageInTicket.get('audioUrl')" 
        [isDoctorImageVariant]="true" 
        [docImg]="userDoctor?.doctorDisplayImage || defaultDoctorImage"
        (emitTrackEvent)="handleClick($event)" >
        </app-custom-audio-waveform>
      </div>
    </div>
</div>
